var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"has-text-white has-text-weight-bold btn3d to-click",class:{['btn-' + _vm.color]: true, ['btn-' + _vm.size]: true, 'block': _vm.block, 'btn-disabled': _vm.active}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }